import { Checkbox } from '@repo/ui/components'
import { useTranslate } from '../../hooks'

interface AdvancedTradeBoxMobileCheckboxProps {
  takeProfit: boolean
  stopLoss: boolean
  onTakeProfitChange: (checked: boolean) => void
  onStopLossChange: (checked: boolean) => void
}

export const AdvancedTradeBoxMobileCheckbox = ({
  takeProfit,
  stopLoss,
  onTakeProfitChange,
  onStopLossChange,
}: AdvancedTradeBoxMobileCheckboxProps) => {
  const { t } = useTranslate()

  // If either is checked, show as checked
  const isChecked = takeProfit || stopLoss

  const handleChange = (checked: boolean) => {
    // When checked, enable both. When unchecked, disable both
    onTakeProfitChange(checked)
    onStopLossChange(checked)
  }

  return (
    <div className='flex items-center gap-xs'>
      <Checkbox checked={isChecked} onCheckedChange={handleChange} size='sm' />
      <span className='text-sm'>{t('order_take_profit_stop_loss')}</span>
    </div>
  )
}
